<template>
  <l-layout :layout="['xs12']">
    <l-data-table
      :get-data-func="getBillList"
      title-text="账单列表"
      @click:row="getDetails($event.item)"
      clickable
      :headers="header"
    >
    </l-data-table>
  </l-layout>
</template>

<script>
import LDataTable from "../../../ladmin/components/LDataTable/LDataTable";
import { BILL_STATUS_TEXT } from "@/object";
export default {
  name: "billList",
  components: { LDataTable },
  data() {
    return {
      header: [
        { text: "车辆号牌", value: "plateNumb", sortable: true, align: "left" },
        { text: "总费用", value: "paidAmount", sortable: false, align: "left" },
        {
          text: "入场时间",
          value: "entryTime",
          sortable: false,
          align: "left",
          f: (v) => this.$L.time.stringify(v),
        },
        {
          text: "入场卡口",
          value: "entryPortName",
          sortable: false,
          align: "left",
        },
        {
          text: "出场时间",
          value: "departureTime",
          sortable: false,
          align: "left",
          f: (v) => this.$L.time.stringify(v),
        },
        {
          text: "出场卡口",
          value: "departurePortName",
          sortable: false,
          align: "left",
        },
        {
          text: "账单状态",
          value: "status",
          sortable: false,
          align: "left",
          f: (v) => BILL_STATUS_TEXT[v],
        },
      ],
    };
  },
  methods: {
    async getBillList({ pagination, sortStack, filterItems = [], search }) {
      let { items, amount } = await this.$store.dispatch("pay/getBillList", {
        pagination,
        sortStack,
        search: { key: "plateNumb", value: search },
        filter: filterItems,
      });
      let list = items.map((item) => ({
        ...item,
        entryPortName: this.findController(item.entryPortId),
        departurePortName: this.findController(item.departurePortId),
      }));
      console.log(list);
      return { items: list, amount: amount };
    },
    getDetails(item) {
      let selectionString = document.getSelection().toString();
      if (!selectionString) {
        this.$router.push({ name: "billDetailBox", query: { id: item.id } });
      }
    },
    findController(id) {
      let controllers = this.$store.state.parkingLot.controllerList;
      for (let i = 0; i < controllers.length; i++) {
        if (controllers[i].id === id) {
          return controllers[i].name;
        }
      }
      return null;
    },
  },
};
</script>

<style scoped>
</style>
